import React from 'react';

import { updatePageLoadInteractionName } from '@atlaskit/react-ufo/interaction-metrics';

/**
 * Updates the UFO event name to
 */
export function ViewPageSplitTinyUFO({ isFabricPage }: { isFabricPage: boolean }) {
	React.useEffect(() => {
		if (!isFabricPage) {
			updatePageLoadInteractionName('view-page-tiny');
		}
	}, [isFabricPage]);
	return null;
}
